import { DatasetScan } from '../dataset/DatasetScan';
import { ScanOption } from '../dataset/ScanOption';
import { Monitor } from './Monitor';

export class DatasetMonitor extends Monitor {
  public declare options: ScanOption | null;
  public declare lastVerification: DatasetScan;

  public get datasetType(): string | undefined {
    return this.response?.datasetType;
  }

  protected transformResponse(): void {
    this.options =
      (this.response?.options && ScanOption.fromMonitorResponse(this.response?.options)) || null;
    this.lastVerification = new DatasetScan(this.response?.lastVerification);
  }
}
